module.exports = __webpack_public_path__ + "img/class_code_bg.4a32fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/class_code_bg.png
// module id = KSMC
// module chunks = 1